<div class="stick-top">
  <mat-toolbar>
    <mat-icon>help</mat-icon> Secure Access Cabinet Log
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button (click)="reload()"><mat-icon>refresh</mat-icon> Refresh</button>&nbsp;
    <micro-checkbox [(checked)]="autoRefresh" negative="Auto-Refresh" positive="Auto-Refreshing"></micro-checkbox>
    <div class="fill-space"></div>
    <micro-date-range [(unit)]="usageFilter.dateRangeUnit" [(from)]="usageFilter.from" [(fromInfinite)]="usageFilter.fromInfinite" [(until)]="usageFilter.until" [(untilInfinite)]="usageFilter.untilInfinite" ></micro-date-range>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th>
          <div class="vbox">
            Date
          </div>
        </th>
        <th>
          <div class="vbox">
            Company
            <micro-company-select *ngIf="auth.hasRole('COMPANY_ADMIN')" [(companyId)]="filter.companyId"></micro-company-select>
            <micro-saHostCompany-select *ngIf="!auth.hasRole('COMPANY_ADMIN')" [(companyId)]="filter.companyId" id="companyId" name="companyId" [includeHosted]="true"></micro-saHostCompany-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            User
            <micro-user-select [(userId)]="filter.userId"></micro-user-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            Name
            <input [(ngModel)]="filter.name">
          </div>
        </th>
        <th>
          <div class="vbox">
            Description
            <input [(ngModel)]="filter.description">
          </div>
        </th>
        <th>
          <div class="vbox">
            Action
            <input [(ngModel)]="filter.action">
          </div>
        </th>
        <th>
          <div class="vbox">
            Serial Number
            <input [(ngModel)]="filter.serialNumber">
          </div>
        </th>
        <th>
          <div class="vbox">
            Site
<!--            <micro-site-select [(siteId)]="filter.siteId"></micro-site-select>-->
            <input [(ngModel)]="filter.siteName">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td>{{element.datetime | dateTime}}</td>
        <td>
          <micro-company-lookup [companyId]="element.companyId" [link]="false"></micro-company-lookup>
        </td>
        <td><micro-user-lookup [userId]="element.userId"></micro-user-lookup></td>
        <td [matTooltip]="element.name">{{element.name}}</td>
        <td [matTooltip]="element.description">{{element.description}}</td>
        <td [matTooltip]="element.action">{{element.action}}</td>
        <td [matTooltip]="element.serialNumber">{{element.serialNumber}}</td>
        <td><micro-site-lookup [siteId]="element.siteId"></micro-site-lookup></td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
